import * as React from "react";

function IcLinkToCareersFill16(props) {
  const {
    accentColor: accent = "#0194F3",
    color = "#687176",
    width = 16,
    height = 16,
    title,
    titleId,
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      data-id="IcLinkToCareersFill16"
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <rect width={16} height={16} />
        <path
          fill={color}
          fillRule="nonzero"
          d="M1,11.5 C1,11.2238576 1.22385763,11 1.5,11 L4,11 C4,11.5522847 4.44771525,12 5,12 C5.55228475,12 6,11.5522847 6,11 L10,11 C10,11.5522847 10.4477153,12 11,12 C11.5522847,12 12,11.5522847 12,11 L14.5,11 C14.7761424,11 15,11.2238576 15,11.5 L15,13 C15,14.1045695 14.1045695,15 13,15 L3,15 C1.8954305,15 1,14.1045695 1,13 L1,11.5 Z M2,3 L4,3 C4,1.34314575 5.34314575,3.04359188e-16 7,0 L9,0 C10.6568542,-3.04359188e-16 12,1.34314575 12,3 L14,3 C15.1045695,3 16,3.8954305 16,5 L16,6.5 C16,8.43299662 14.4329966,10 12.5,10 L12,10 C12,9.44771525 11.5522847,9 11,9 C10.4477153,9 10,9.44771525 10,10 L6,10 C6,9.44771525 5.55228475,9 5,9 C4.44771525,9 4,9.44771525 4,10 L3.5,10 C1.56700338,10 -6.86870354e-15,8.43299662 -7.10542736e-15,6.5 L-7.10542736e-15,5 C-7.24069811e-15,3.8954305 0.8954305,3 2,3 Z M7,2 C6.44771525,2 6,2.44771525 6,3 L10,3 C10,2.44771525 9.55228475,2 9,2 L7,2 Z"
        />
      </g>
    </svg>
  );
}

export default IcLinkToCareersFill16;
